module.exports = __webpack_public_path__ + "img/regal.db120dbc.png";